import { UserResponse } from "../models/responses/user-response";
import { localStoragevarNames } from "./local-storage-utils";

export const getConnectedUserFromLocalStorage = (): UserResponse => {
    return JSON.parse(localStorage.getItem(localStoragevarNames.user)!);
}

export const resetUserInLocalStorage = (userResponse:UserResponse): void => {
    localStorage.setItem(localStoragevarNames.user,JSON.stringify(userResponse));
}
